import useComplianceView from "./useComplianceView";

export default function useEventDetailsStatuses() {
  const {
    filters,
    filters: { status, selectedStatuses },
    statusCounts,
    setViewData,
  } = useComplianceView();

  const onStatusChange = ({ id }) => {
    const newStatuses = [...selectedStatuses];

    if (newStatuses.includes(id)) {
      setViewData({
        filters: {
          ...filters,
          selectedStatuses: newStatuses.filter((x) => x !== id),
        },
      });
    } else {
      setViewData({
        filters: { ...filters, selectedStatuses: [...selectedStatuses, id] },
      });
    }
  };

  return {
    status,
    statusCounts,
    selectedStatuses,
    onStatusChange,
  };
}
